import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Loginn.css";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const LOGIN_API = `https://devskillz-ifm6.onrender.com/api/student/login`;

  // GOOGLE LOGIN HANDLER
  const handleGoogleLogin = () => {
    window.location.href = `https://devskillz-ifm6.onrender.com/api/auth/google`;
  };

  // FORGOT PASSWORD HANDLER
  const handleForgotPassword = () => {
    // You can later replace this with a real page or modal
    window.location.href = "/forgot-password";
  };

  // Auto login if redirected from Google OAuth
  useEffect(() => {
    const url = new URL(window.location.href);

    if (url.searchParams.get("success") === "1") {
      alert("Google Login Successful 🎉");

      localStorage.setItem("user", JSON.stringify({ google: true }));
      localStorage.setItem("token", "google-auth");

      window.location.href = "/StudentDashboard";
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await axios.post(
        LOGIN_API,
        { username, password },
        { withCredentials: true }
      );

      alert("Login successful!");

      localStorage.setItem("user", JSON.stringify(res.data.student));
      localStorage.setItem("token", res.data.token);

      window.location.href = `/StudentDashboard/${res.data.student.id}`;
    } catch (err) {
      console.log("LOGIN ERROR:", err.response?.data);
      setError(err.response?.data?.error || "Server error. Try again.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <h2>Welcome Back</h2>
        <p className="subtitle">Log in to your account</p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Username or Email"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {/* FORGOT PASSWORD */}
          <div className="forgot-password">
            <span onClick={handleForgotPassword}>
              Forgot Password?
            </span>
          </div>

          <button type="submit">Log In</button>

          {error && <p className="error">{error}</p>}
        </form>

        {/* GOOGLE LOGIN BUTTON */}
        <button className="google-btn" onClick={handleGoogleLogin}>
          <img
            src="https://developers.google.com/identity/images/g-logo.png"
            alt="Google"
            style={{ width: "18px", marginRight: "10px" }}
          />
          Sign in with Google
        </button>

        <div className="register-link">
          <p>
            New User?{" "}
            <span
              style={{ color: "#007bff", cursor: "pointer", fontWeight: "bold" }}
              onClick={() => (window.location.href = "/register")}
            >
              Register Here
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
